import * as D from '../../../utils/dbmodel';

export default {
    namespaced: true,
    state: {
        searchP:{
            rolename:'',//用户姓名
            iseffective:'',
        },
        list: [], //table中的list显示数据
        pagination: {
            
        }, //分页相关的信息
        record: {}, //根据id查询的数据详情信息
    },

    getters: {
        getDomainnameSelectOptions(state) {
            return state.domainnameSelectOptions
        }
    },

    mutations: {
        save(state, action) {
            // console.log(action, "commit")
            // state = { ...state, ...action.payload }   //这么写不行，必须要遍历挨个重新赋值
            // state.domainnameSelectOptions = action.payload.domainnameSelectOptions
            for (var key in action.payload) {
                state[key] = action.payload[key]
            }
            // console.log(state, " yo ?") //跟console.log({ ...state, ...action.payload }) 的值是不一样的, 所以不能直接用展开运算符
        }
    },

    actions: {
        getEmptyRole(context){
            context.commit({
                type: 'save',
                payload: {
                    record: {
                        
                    }
                }
            })
        },
        //查询
        selectRole(context, payload) {
            return D.select({
                ...payload
            })

        },

        //添加角色
        addRole(context, payload) {
            return D.add({
                ...payload
            })
        },

        //查询已授权或未授权用户
        selectAuthUser(context, payload) {
            return D.select({
                ...payload
            })
        },

        //菜单敏感数据设置
        updateMenu(context, payload) {
            return D.edit({
                ...payload
            })
        },

        //用户授权查询用户接口
        selectRoleUser(context, payload) {
            return D.select({
                ...payload
            })
        },

        //授权页删除用户接口
        deleteAuthUser(context, payload) {
            return D.del({
                ...payload
            })
        },

        //获取所有菜单
        getAllMenu(context, payload) {
            return D.select({
                ...payload
            })
        },

        //编辑角色
        updateRole(context, payload) {
            return D.edit({
                ...payload
            })
        },

        getEmptySearch(context){
            context.commit({
                type: 'save',
                payload: {
                    searchP: {
                        rolename:'',//角色名称
                        iseffective:'',//有效性
                    }
                }
            })
        },

        //获取角色信息
        getRole(context, payload) {
            return D.select({
                ...payload
            }).then(response => {
                const { data } = response.data;
                context.commit({
                    type: 'save',
                    payload: {
                        record: data
                    }
                })
                return response
            })
 
        },

        //授权
        authUser(context, payload) {
            return D.edit({
                ...payload
            })
        },

        //有效无效
        activeRole(context, payload) {
            return D.edit({
                ...payload
            })
        },
    }
}